import { startOfMinute, getUnixTime } from "date-fns";
import type { MetaData } from "../types/campaign";
import { waitForMs } from "./helpers/await";
export const getUnixTimeMinuteGranularity = (): number => {
  const now = new Date();
  const minuteStart = startOfMinute(now);
  return getUnixTime(minuteStart);
};

const getCurrentTimestamp = (metadata: MetaData, start: string): number | null => {
  const currentPhaseKeys = Object.keys(metadata).filter((key) => key.startsWith(start));

  const currentTimestamp = currentPhaseKeys.reduce((memo: number | null, key: string) => {
    const components = key.split("_");
    const timestamp = parseInt(components.pop() || "", 10);

    return (memo === null || memo < timestamp) ? timestamp : memo;
  }, null);

  return currentTimestamp;
};

const getCurrentKeyValue = (metadata: MetaData, start: string): string => {
  return metadata[`${start}${getCurrentTimestamp(metadata, start)}`] as string;
};

export const getCurrentProcess = (metadata: MetaData): string => getCurrentKeyValue(metadata, "current_process_");
export const getCurrentPhase = (metadata: MetaData): string => getCurrentKeyValue(metadata, "current_phase_");

export const getCurrentPhaseKey = (metadata: MetaData): string => {
  return `current_phase_${getCurrentTimestamp(metadata, "current_phase_")}`;
};

export const getCurrentProcessKey = (metadata: MetaData): string => {
  return `current_process_${getCurrentTimestamp(metadata, "current_process_")}`;
};

export function clickOutside(node: HTMLElement) {
  const handleClick = (event: MouseEvent) => {
    if (!node.contains(event.target as Node)) {
      node.dispatchEvent(new CustomEvent("outclick"));
    }
  };

  document.addEventListener("click", handleClick, true);

  return {
    destroy() {
      document.removeEventListener("click", handleClick, true);
    }
  };
}

type RetryOptions = {
  fn: () => Promise<void>,
  maxAttempts?: number,
  currentAttempt?: number,
  backoffMs?: number
}

export async function withRetry({fn, maxAttempts = 3, currentAttempt = 1, backoffMs = 1000}: RetryOptions) {
  try {
    await fn();
  } catch (e) {
    if (currentAttempt >= maxAttempts) {
      throw e;
    } else {
      await waitForMs(backoffMs * currentAttempt);
    }
    return withRetry({fn, maxAttempts, currentAttempt: currentAttempt + 1, backoffMs});
  }
}
